export default __webpack_public_path__ + "images/smart_labeling-4Ufbt.gif";